/**
 * Tokens de modales — misma identidad "Trazia Ink" que el CRM.
 * Base minimalista + acción principal en gradiente ink; azul como acento.
 */
export const MODAL = {
  bg: "var(--tz-surface-muted)",
  surface: "var(--tz-surface)",
  border: "var(--tz-border)",
  borderStrong: "var(--tz-border-strong)",
  text: "var(--tz-text)",
  textSecondary: "var(--tz-text-secondary)",
  textMuted: "var(--tz-text-muted)",

  ink: "var(--tz-ink)",
  inkGradient: "var(--tz-ink-gradient)",
  inkGradientHover: "var(--tz-ink-gradient-hover)",
  inkSoft: "rgba(15, 23, 42, 0.055)",
  inkShadow: "0 6px 16px rgba(15, 23, 42, 0.18)",
  inkShadowHover: "0 10px 24px rgba(15, 23, 42, 0.24)",

  // Azul — acento funcional
  primary: "#2563eb",
  primaryHover: "#1d4ed8",
  primarySoft: "rgba(37, 99, 235, 0.06)",
  primaryRing: "rgba(37, 99, 235, 0.18)",

  hover: "var(--tz-hover)",
  danger: "#ef4444",
  dangerHover: "#dc2626",
  dangerSoft: "rgba(239, 68, 68, 0.08)",
  dangerRing: "rgba(239, 68, 68, 0.18)",
  success: "#16a34a",
  successSoft: "rgba(34, 197, 94, 0.08)",
  shadow: "0 24px 48px rgba(15, 23, 42, 0.12), 0 8px 16px rgba(15, 23, 42, 0.05)",
  backdrop: "rgba(15, 23, 42, 0.34)",
  radius: "16px",
  radiusSm: "8px",
};

export const modalScroll = {
  "&::-webkit-scrollbar": { width: 6 },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    background: "#cbd5e1",
    borderRadius: 8,
  },
  scrollbarWidth: "thin",
  scrollbarColor: "#cbd5e1 transparent",
};

export const modalFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: MODAL.radiusSm,
    fontSize: "0.8125rem",
    bgcolor: MODAL.surface,
    transition: "box-shadow .15s ease, border-color .15s ease",
    "& fieldset": { borderColor: MODAL.border },
    "&:hover fieldset": { borderColor: MODAL.borderStrong },
    "&.Mui-focused fieldset": {
      borderColor: MODAL.primaryRing,
      borderWidth: "1px",
    },
    "&.Mui-focused": {
      boxShadow: `0 0 0 3px ${MODAL.primarySoft}`,
    },
    "&.Mui-error fieldset": { borderColor: MODAL.danger },
    "&.Mui-error.Mui-focused": {
      boxShadow: `0 0 0 3px ${MODAL.dangerSoft}`,
    },
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.8125rem",
    color: MODAL.textSecondary,
    "&.Mui-focused": { color: MODAL.primary },
  },
  "& .MuiFormHelperText-root": {
    fontSize: "0.75rem",
    mx: 0,
    mt: 0.75,
  },
};

/** Acción principal del modal — gradiente ink (firma visual). */
export const modalBtnPrimary = {
  textTransform: "none",
  fontWeight: 650,
  fontSize: "0.8125rem",
  borderRadius: MODAL.radiusSm,
  color: "#fff",
  background: MODAL.inkGradient,
  boxShadow: MODAL.inkShadow,
  px: 2.25,
  py: 0.875,
  minWidth: 96,
  transition: "filter .15s ease, box-shadow .18s ease, transform .12s ease",
  "&:hover": {
    background: MODAL.inkGradient,
    filter: "brightness(1.12)",
    boxShadow: MODAL.inkShadowHover,
  },
  "&:active": { transform: "translateY(0.5px)" },
  "&.Mui-disabled": { background: "#cbd5e1", color: "#fff", boxShadow: "none" },
};

export const modalBtnGhost = {
  textTransform: "none",
  fontWeight: 550,
  fontSize: "0.8125rem",
  borderRadius: MODAL.radiusSm,
  color: MODAL.textSecondary,
  border: `1px solid ${MODAL.border}`,
  bgcolor: MODAL.surface,
  boxShadow: "none",
  px: 2.25,
  py: 0.875,
  minWidth: 96,
  transition: "background .15s ease, border-color .15s ease, color .15s ease",
  "&:hover": { bgcolor: MODAL.hover, borderColor: MODAL.borderStrong, color: MODAL.text, boxShadow: "none" },
};

export const modalBtnDanger = {
  textTransform: "none",
  fontWeight: 650,
  fontSize: "0.8125rem",
  borderRadius: MODAL.radiusSm,
  bgcolor: MODAL.danger,
  color: "#fff",
  boxShadow: "none",
  px: 2.25,
  py: 0.875,
  minWidth: 96,
  "&:hover": { bgcolor: MODAL.dangerHover, boxShadow: "none" },
};
